import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useSelectedCustomerStore } from "@/shared/stores/SelectedCustomerStore";
import { Roles } from "@/shared/@types/Roles";

export const useEquivoltRoles = () => {
  const selectedCustomerStore = useSelectedCustomerStore();
  const { customerRoles } = storeToRefs(selectedCustomerStore);

  const isHomeUser = computed(() =>
    customerRoles.value.includes(Roles.FLEET_AT_HOME_USER),
  );
  const isHomeManager = computed(() =>
    customerRoles.value.includes(Roles.FLEET_AT_HOME_MANAGER),
  );
  const isPreSalesManager = computed(() =>
    customerRoles.value.includes(Roles.EQUIVOLT_PRE_SALES_MANAGER),
  );

  return {
    isHomeUser,
    isHomeManager,
    isPreSalesManager,
  };
};
